export default "__VITE_ASSET__CgtHZKmE__"